<template>
  <div>
    <van-action-sheet v-model="searchStudentShow" title="学生搜索" @closed="searchStudentClose">
      <div class="classesContent">
        <van-search v-model="stuSearchKey" @search="stuSearch" placeholder="请输入姓名或学号搜索关键词"/>
        <van-cell-group inset>
          <van-cell
            :class="selected.id==item.id?'classesSelected':''"
            :title="item.sName" :value="item.sNum" v-for="(item,index) in students" @click="adminSelect(item)"
            :key="index"/>
        </van-cell-group>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  getStuListLikeKeyByPage,
} from "@/network/student";
import {
  ActionSheet,
  Search,
  CellGroup,
  Cell
} from 'vant';
import SearchStudent from "@/components/content/SearchStudent/SearchStudent.vue";

Vue.use(ActionSheet);
Vue.use(Search);
Vue.use(CellGroup);
Vue.use(Cell);
export default {
  name: "SearchStudent",
  computed: {
    SearchStudent() {
      return SearchStudent
    }
  },
  props: ['searchStudentShow'],
  data() {
    return {
      // 学生搜索 action sheet
      selected: {},
      students: [],
      stuShow: false,
      stuSearchKey: "",
    }
  },
  methods: {
    stuSearch() {
      getStuListLikeKeyByPage(this.stuSearchKey, 1).then(res => {
        this.students = res;
      })
    },
    adminSelect(item){
      this.selected=item;
      this.$emit('selectedSearchStu', item)
    },
    searchStudentClose(){
      this.$emit('closed', false)
      console.log(this.searchStudentShow);
    }
  }
}
</script>

<style scoped>
.classesContent {
  padding: 16px 16px 360px;
}

.classesSelected {
  color: #7dbfff;
  font-weight: bold;
}
</style>
